import { notEmpty } from '@festina-life/core'

import { IconButton } from '../../../actions/iconButton/IconButton'
import { DateRangePicker } from '../../../forms/datePicker/DateRangePicker'
import { useTranslate } from '../../../hooks/useTranslate'
import { Dropdown } from '../../../structure/dropdown/Dropdown'
import type { ColumnFilterState } from '../useFilterState'

type State<T> = ColumnFilterState<T> & { type: 'dateRange' }

type Props<T> = {
  state: State<T>
  onStateChanged: (state: State<T>) => void
}

export const DateRangeFilter = <T,>({ state, onStateChanged }: Props<T>) => {
  const translate = useTranslate()

  return (
    <Dropdown
      element={
        <IconButton
          tip={translate('filter')}
          iconName="Filter"
          isSelected={notEmpty(state.min || state.max)}
          className="-m-1"
        />
      }
      items={[
        {
          element: (
            <DateRangePicker
              wrapperProps={{
                label: translate('table.filter.dateRangeTitle'),
                className: 'py-0!',
              }}
              value={{
                start: state.min ?? undefined,
                end: state.max ?? undefined,
              }}
              onChange={({ start, end }) =>
                onStateChanged({
                  ...state,
                  min: start || null,
                  max: end || null,
                })
              }
            />
          ),
        },
      ]}
    />
  )
}
